import { BranchState } from '../types/entities/branch'
import { axios } from '../utils'

export const fetchWindowBranch = async (id: string): Promise<BranchState> => {
  const result = await axios.get<BranchState>(`/v1/branch/${id}`)
  return result && result.data
}
